function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshIcon = function SvgRefreshIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.65 6.35a7.95 7.95 0 0 0-6.48-2.31 8 8 0 1 0 8.04 11.4 1 1 0 0 0-.9-1.44.973.973 0 0 0-.88.53A6 6 0 1 1 12 6a5.915 5.915 0 0 1 4.22 1.78l-1.51 1.51a1 1 0 0 0 .7 1.71H19a1 1 0 0 0 1-1V6.41a1 1 0 0 0-1.71-.71l-.64.65Z",
    style: {
      fill: "#718096"
    }
  }));
};
export default SvgRefreshIcon;